import packageJson from "../../package.json"; // Import package.json
import { getRuntimeConfig } from "./runtimeConfig";

const getConnectionString = () => {
  try {
    const rc = getRuntimeConfig();
    return {
      ws: "https://app-sg-cc-eecbkend01d.azurewebsites.net",
      WSUserName: rc.wsUserName,
      WSPWD: rc.wsPwd,
      DebugUserName: "",
      appBaseName: packageJson.homepage === "./" || packageJson.homepage === "/" ? "" : packageJson.homepage,
    };
  } catch {
    // Fallback for dev / before runtime config is loaded
    return {
      ws: "https://eecapi.dksh.com",
      WSUserName: "bsadmin",
      WSPWD: "bsadmindksh",
      DebugUserName: "",
      appBaseName: packageJson.homepage === "./" || packageJson.homepage === "/" ? "" : packageJson.homepage,
    };
  }
};

const appConfig = {
  connectionString: {
    ws: "https://app-sg-cc-eecbkend01d.azurewebsites.net", // Set your api endpoint here
    DebugUserName: "",
    appBaseName: packageJson.homepage == "./" || packageJson.homepage == "/" ? "" : packageJson.homepage,
  },
  Post: "POST",
  Get: "GET",
  Put: "PUT",
  Delete: "DELETE",
  ClaimItem: "CLAIM_ITEM",
  GetApiByPageType: "/api/GetApiByPageType",
  quickAddPage: {
    allowedFileType: ".pdf,.jpg,.png,.jpeg",
    allowedImageType: ".jpg,.png,.jpeg",
    allowedLargeFileType: "",
    fileSizeLimit: 5242880,
    scanFileSizeLimit: 2097152,
    scanMaxFileCount: 10,
    fileSizeLarge: 10485760,
  },
  PerDiemControlCountry: "JP,HK,MO,CN,TH,MM",
  AccommodationCountry: "TH",
  PerDiemColumn: 10,
  FlexiClaimCSSC: "MY98",
  OTMealsCountry: "SG,",
  NoRecoverableCompany: "MY98",
  NoRecoverableCountry: "JP,AU,NZ,TH",
  FormSimplificationCompany:
    "MY98,FR80,JP80,JP86,MM80,MM82,MM83,ES80,TH82,TH83,TH84,TH88,TH8A,TH92,TH95,TH97,TH9B,CH84",
  RecipientTemplateLink:
    "https://dksh.sharepoint.com/:x:/t/it/ita/td/web/EWQjby4IF4pNrrxlw1lP8msBN-o-3a6dEDSFjPF6iOEVfg",
  // Begin,Saber,20261026 - MY mileage template from testing Web.config. The July 2024 file no longer exists.
  MileageTemplateLink:
    "https://dksh.sharepoint.com/:x:/r/teams/finance/_layouts/15/Doc.aspx?sourcedoc=%7BE831E130-6142-4941-8DEB-561D5712F983%7D&file=MY_Mileage%20calculation%20template%20as%20at%204%20Jul25.xlsm&action=default&mobileredirect=true",
  CurrencyDecimal: "JPY,KRW,TWD",
  DecimalRounding45Rule: "TW",
  InternalOrderEvent: "NZ90,NZ91,NZ92,PT80,CH87,DE82,CA80",
  THHRBAUSERLIST:"88000615,88004707,88005717,88034485,88050494,99TESTDE",
  LocalCashAdvanceCountry:"PH,LA,ID,KH", //Hazel Add "KH" for SR-835634 Cash Advance Request without Pre-approval Form
  AccommodationAllowanceColumn: 320,
  HelpFileLink:
    "https://dksh.sharepoint.com/teams/finance/Finance%20System/Forms/Business%20View.aspx",
  // Interim link back to the legacy (on-prem) EEC Plus system. Update this once
  // eecplus.dksh.com is repointed to the cloud app at go-live to the legacy system's new stable URL.
  LegacySystemUrl: "https://eecplus.dksh.com",
  InvoiceDateExceededWarning: "SG,MY",
  HideShowTaxableFieldsCountry: "TH",
  AIScanReceiptCountry: "*",
  PWACountryList: "SG,MY,TW,KR,CN,DE,DK,ES,FR,IT,NL,PT,CH,GB,NO,AU,NZ,CA,US,BN,KH,ID,LA,MM,PH,VN",
  Version: "3.2.9",
};

export default appConfig;
